import { SET_TREE_FIELD } from './actions';

const initialState = {
    items: [],
    clicked: false,
    isLoaded: false,
    selected: '',
    selectedItem: [],
    parent: [],
    catalogParentId: [],
};

export function treeReducer(state = initialState, action) {
    switch (action.type) {
        case SET_TREE_FIELD:
            return { ...state, [action.key]: action.value };
        default:
            return state;
    }
}
